// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap__3x1--","fixed_wrap":"index_fixed_wrap__1KNOI","logo":"index_logo__2hqK3"};